import { Pipe } from '@angular/core';
import { isUndefined } from '../helpers/helpers';
var IsUndefinedPipe = (function () {
    function IsUndefinedPipe() {
    }
    IsUndefinedPipe.prototype.transform = function (input) {
        return isUndefined(input);
    };
    IsUndefinedPipe.decorators = [
        { type: Pipe, args: [{ name: 'isUndefined' },] },
    ];
    /** @nocollapse */
    IsUndefinedPipe.ctorParameters = function () { return []; };
    return IsUndefinedPipe;
}());
export { IsUndefinedPipe };
//# sourceMappingURL=is-undefined.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-undefined.js
// module id = 255
// module chunks = 4